import React, { FC, useRef, useState } from 'react';
import clsx from 'clsx';
import { SelectOptionProps } from '../types';
import styles from '../BlockSelect.module.css';

interface OptionProps {
  id: string;
  option: SelectOptionProps;
  active: boolean;
  selected: SelectOptionProps | null;
  onClick: (option: SelectOptionProps) => void;
}

const getBgClass = (
  active: boolean,
  selected: boolean,
  hovered: boolean,
): string => {
  if (selected && hovered) return styles.deepskyblue;
  if (selected && active) return styles.deepskyblue;
  if (hovered) return styles.ghostwhite;
  if (selected) return styles.lightblue;
  if (active) return styles.whitesmoke;

  return styles.transparent;
};

export const Option: FC<OptionProps> = ({
  id,
  option,
  selected,
  active,
  onClick,
}) => {
  const [hovered, setHovered] = useState(false);

  const optionRef = useRef<HTMLLIElement>(null);

  const handleClick = () => {
    onClick(option);
  };

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const isSelected = selected?.value === option.value;

  const classes = clsx({
    [getBgClass(active, isSelected, hovered)]: true,
    [styles.option]: true,
  });

  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    <li
      id={id}
      className={classes}
      ref={optionRef}
      role="option"
      aria-selected={option.value === selected?.value}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {option.label}
    </li>
  );
};
